const US = {
    moduleTitle: 'Product Support',
    all: 'View All',
    less: 'View Less',
};
export const B_DATA: {
    [key: string]: {
        moduleTitle: string;
        all: string;
        less: string;
    };
} = {
    us: {
        ...US,
    },
    eu: {
        ...US,
    },
    uk: {
        ...US,
    },
    ca: {
        ...US,
    },
    au: {
        ...US,
    },
    za: {
        ...US,
    },
    cn: {
        moduleTitle: '产品支持',
        all: 'View All',
        less: 'View Less',
    },
    de: {
        moduleTitle: 'Produktsupport',
        all: 'Alles anzeigen',
        less: 'Weniger anzeigen',
    },
    fr: {
        moduleTitle: 'Assistance produit',
        all: 'Voir tout',
        less: 'Afficher moins',
    },
    it: {
        moduleTitle: 'Supporto tecnico',
        all: 'Visualizza tutto',
        less: 'Mostra meno',
    },
    es: {
        moduleTitle: 'Asistencia sobre productos',
        all: 'Ver todo',
        less: 'Ver menos',
    },
    jp: {
        moduleTitle: '製品のサポート',
        all: 'すべて表示',
        less: '少なく表示',
    },
    kr: {
        moduleTitle: '제품 지원',
        all: '모두 보기',
        less: '간략히 보기',
    },
    sa: {
        moduleTitle: 'دعم المنتج',
        all: 'View All',
        less: 'View Less',
    },
    tw: {
        moduleTitle: '產品支援',
        all: 'View All',
        less: 'View Less',
    },
    br: {
        moduleTitle: 'Suporte ao produto',
        all: 'View All',
        less: 'View Less',
    },
    mx: {
        moduleTitle: 'Asistencia sobre productos',
        all: 'Ver todo',
        less: 'Ver menos',
    },
    nl: {
        moduleTitle: 'Productondersteuning',
        all: 'Alles bekijken',
        less: 'Minder weergeven',
    },
    Physics2DPlugin: {
        ...US,
    },
};
